// @flow
import React from "react";
import ParkAndRide from "../../../svg/facilities/park_and_ride.svg";
import "./parkAndRideIcon.scss";

const ParkAndRideIcon = () => <ParkAndRide className="c-park-and-ride-icon" />;

export default ParkAndRideIcon;
